import * as WebBrowser from 'expo-web-browser';
import { Platform } from 'react-native';
import Text from '@/components/UI/Text';
import useHaptics from '@/hooks/useHaptics';
import useUserId from '@/hooks/useUserId';
import ActionButton from '../../UI/ActionButton';
import Box from '../../UI/Box';
import Card from '../../UI/Card';
import Icon from '../../Unistyles/Icon';

export default function EventShareCalendarDownload() {
  const userId = useUserId();
  const calendarSubscriptionUrl = `${process.env.EXPO_PUBLIC_SERVICES_URL}/calendarFeed/person/${userId}`;

  const onGetFile = useHaptics(async (url: string) => {
    if (Platform.OS === 'web') {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = 'Your 1Time Calendar.ics';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(objectUrl);
      } catch {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
      return;
    }

    await WebBrowser.openBrowserAsync(url, {
      windowFeatures: 'noopener,noreferrer',
      windowName: '_blank',
    });
  });

  return (
    <Card space="lg" p="lg" w="full">
      <Box
        space="md"
        direction="horizontal"
        justifyContent="space-between"
        flexWrap="wrap"
        alignItems="center"
      >
        <Box
          direction="horizontal"
          alignItems="center"
          justifyContent="flex-start"
          space="md"
        >
          <Icon name="download-outline" size="3xl" />
          <Text size="3xl" flexShrink={1}>
            Calendar Download
          </Text>
        </Box>

        <Box space="md" direction="horizontal">
          <ActionButton
            forceLabel
            icon="download-outline"
            variant="secondary"
            label="Download"
            onPress={() => onGetFile(calendarSubscriptionUrl)}
          />
        </Box>
      </Box>
      <Text>
        Add your 1Time Calendar to your calendar app the old-fashioned way.
      </Text>
      <Text variant="warning">
        Note if you do this you will not get updates when there are changes in
        1Time.
      </Text>
    </Card>
  );
}
